import WorkflowModel from '@opsbase/lib-data-model/models/WorkflowModel';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import FeatureStatus from '@opsbase/lib-system/FeatureStatus';
import WorkflowMetaModelRegistry from '@opsbase/lib-workflow/workflow-metamodel/WorkflowMetaModelRegistry';
import WorkflowAction from '@opsbase/lib-workflow/WorkflowAction';
import WorkflowActionType, { workflowActionTypeLabel, } from '@opsbase/lib-workflow/WorkflowAction/WorkflowActionType';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useCallforward from '@opsbase/react-hooks/useCallforward';
import AddIcon from '@opsbase/web-icons/icons/AddIcon';
import DeleteIcon from '@opsbase/web-icons/icons/DeleteIcon';
import Horizontal from '@opsbase/web-layout/Horizontal/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical/Vertical';
import IconButton from '@opsbase/web-ui/IconButton';
import IconMenu from '@opsbase/web-ui/IconMenu';
import MenuItem from '@opsbase/web-ui/MenuItem/MenuItem';
import Text from '@opsbase/web-ui/Text/Text';
import WorkflowActionPicker from '@opsbase/web-workflow/WorkflowActionPicker';
import React, { useMemo, useState } from 'react';
import WorkflowDialogColumn from './WorkflowDialogColumn';
export function WorkflowDialogActions(props) {
    var _a, _b;
    const { workflow = new WorkflowModel(), onChange, editable } = props;
    const [expActionIdx, setExpActionIdx] = useState();
    let availableActions = (_a = WorkflowMetaModelRegistry[workflow === null || workflow === void 0 ? void 0 : workflow.event]) === null || _a === void 0 ? void 0 : _a.actions;
    // Filter workflow actions that are not enabled by feature flag
    const self = useSelf();
    const iqmIntegrationSetting = self.features.find(f => f.name === 'INTEGRATIONS_IQM');
    const isIQMEnabled = iqmIntegrationSetting
        ? iqmIntegrationSetting.state === FeatureStatus.ENABLED
        : false;
    if (!isIQMEnabled ||
        (isIQMEnabled &&
            workflow.actions
                .map(a => a.workflowActionType)
                .includes(WorkflowActionType.IQM_CREATE_WORKFLOW))) {
        availableActions = availableActions.filter(a => a.workflowActionType !== WorkflowActionType.IQM_CREATE_WORKFLOW);
    }
    const handleChangeAction = useCallforward(i => a => {
        var _a;
        if (((_a = workflow === null || workflow === void 0 ? void 0 : workflow.actions) === null || _a === void 0 ? void 0 : _a.length) > i) {
            workflow.actions[i] = a;
        }
        else {
            workflow.actions.push(a);
        }
        onChange(new WorkflowModel(workflow));
        setExpActionIdx(i);
    }, [workflow, onChange]);
    const handleActionDelete = useCallforward((i) => () => {
        workflow.actions.splice(i, 1);
        onChange(new WorkflowModel(workflow));
        setExpActionIdx(undefined);
    }, [workflow, onChange]);
    const handleAddAction = useCallforward((a) => () => {
        const newA = new WorkflowAction(a);
        if (workflow) {
            workflow === null || workflow === void 0 ? void 0 : workflow.actions.push(newA);
            onChange(new WorkflowModel(workflow));
        }
        setExpActionIdx((workflow === null || workflow === void 0 ? void 0 : workflow.actions.length) - 1);
    }, [workflow, onChange]);
    const handleExpandAction = useCallforward(i => () => {
        if (expActionIdx === i) {
            setExpActionIdx(undefined);
        }
        else {
            setExpActionIdx(i);
        }
    }, [expActionIdx]);
    const renderAction = useMemo(() => (a, i) => (React.createElement(Horizontal, { key: 'action' + i, gutter: true, centered: true, shrink: true },
        React.createElement(WorkflowActionPicker, { disabled: !editable, event: workflow === null || workflow === void 0 ? void 0 : workflow.event, expanded: expActionIdx === i, onExpand: handleExpandAction(i), action: a, onChangeAction: handleChangeAction(i) }),
        React.createElement(IconButton, { disabled: !editable, onClick: handleActionDelete(i), icon: React.createElement(DeleteIcon, { size: 20, color: Palette.PastelBlue }) }))), [
        expActionIdx,
        handleActionDelete,
        handleChangeAction,
        handleExpandAction,
        editable,
        workflow,
    ]);
    return (React.createElement(WorkflowDialogColumn, { title: i18n.t('then').toUpperCase() },
        React.createElement(Vertical, { gutter: true, shrink: true }, (_b = workflow === null || workflow === void 0 ? void 0 : workflow.actions) === null || _b === void 0 ? void 0 : _b.map(renderAction)),
        React.createElement(Pane, { paddingY: true },
            React.createElement(IconMenu, { disabled: !editable, key: 'iconMenu', background: true, icon: React.createElement(AddIcon, null), label: (workflow === null || workflow === void 0 ? void 0 : workflow.actions.length) ? i18n.t('and').toUpperCase() : i18n.t('add'), anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                } },
                React.createElement(Vertical, { gutter: true }, availableActions === null || availableActions === void 0 ? void 0 : availableActions.map((a, i) => (React.createElement(MenuItem, { key: 'newAction' + i, onClick: handleAddAction(a) },
                    React.createElement(Text, null, workflowActionTypeLabel(a.workflowActionType))))))))));
}
export default WorkflowDialogActions;
